import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

// ----------------------------------------------------------------------

const muiSelect = (theme) => {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreRoundedIcon,
        variant: 'outlined',
      },

      styleOverrides: {
        select: {
          height: '48px',
          fontSize: '14px',
          lineHeight: '17.71px',
          fontWeight: 400,
          display: 'flex',
          alignItems: 'center',
        },

        sizeSmall: {
          height: '40px',
          fontSize: '12px',
          lineHeight: '15.18px',
          fontWeight: 400,
        },
      },
    },
  };
};

export default muiSelect;
